import React, {Component} from 'react';
import FocusPageId from "../../FocusPageId";
import {Link} from "react-router-dom";

let i=0;
class OperatingCompany extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }
    constructor(props) {
        super(props);

        this.positionAdject=this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };
    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 id="a"><b>運営会社について</b></h3></li>
                     <div className="brElement"></div>

                    <p className='all-content-font-size'>
                    </p>
                    <p className='all-content-font-size'> 私たちのミッションは、ネット上でみなさまのモノづくり環境を継続的に支えること。
                    </p>
                    <p className='all-content-font-size'> 顧客の満足を満たすシステムのあり方を共に模索し、安定的なサポートを提供し続ける存在を目指します。
                    </p>
                    <p className='all-content-font-size'> モノづくりのパートナーとしての存在を確立すること、そしてその関係を多くの企業と結び、広げていくこと。
                    </p>
                    <p className='all-content-font-size'> そうすることで、少しずつ、着実に会社としての成長を図っていきたいと思います。
                    </p>
                     <div className="brElement"></div>
                    <p className='all-content-font-size'> RIZEN HK LIMITED
                    </p>
                    <p className='all-content-font-size'> 所在地：Unit 904, 9/F, Tern Plaza, 5 Cameron Road, Tsim Sha Tsui, Kowloon, Hong Kong
                    </p>
                    <p className='all-content-font-size'> 代表者：谷本了一
                    </p>
                    <p className='all-content-font-size'> 電話 ：+852 2369 8781
                    </p>
                    <p className='all-content-font-size'> Mail ：Service＠kitcutlabo.com
                    </p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/memberregistrationTopic">
                            <span className='font-size-20'>
                           戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default OperatingCompany;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/OperatingCompany.js